import { IconButton } from '@mui/material';
import { useState } from 'react';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { tramites } from '../../utils/listadoTramites';
import styles from './offcanvas.module.css'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';

function OffCanvasMenu() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
    <IconButton onClick={handleShow}>
    <MenuRoundedIcon/>
    </IconButton>
      <Offcanvas show={show} onHide={handleClose}>
        <Offcanvas.Header className={styles.header} closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <div className={styles.linksContainer}>
            <a className={styles.link} href='/tramites'><HomeRoundedIcon style={{ fontSize: 35, color: "#45B39D" }}/>Inicio</a>
        {tramites.map((tramite,i) => {
          return ( <a className={styles.link} key={i} href={tramite.navegator}>{tramite.icon}{tramite.title}</a>)
        })}
        </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default OffCanvasMenu;